import React from 'react';
import { Rate, Typography } from 'antd';
import { StarOutlined } from '@ant-design/icons';
import { DIFFICULTY_LABELS } from '../constants';

const { Text } = Typography;

const DifficultySelector = ({ value, onChange, style = {} }) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '12px', ...style }}>
      <Rate 
        character={<StarOutlined />}
        value={value}
        onChange={onChange}
        style={{ fontSize: '16px' }}
      />
      <Text type="secondary" style={{ fontSize: '12px', minWidth: '80px' }}>
        {DIFFICULTY_LABELS[value - 1]}
      </Text>
    </div>
  );
};

export default DifficultySelector;
